import type { RoleHelper } from '@/helpers/RoleHelper.ts'
import type { RouteRecordRaw } from 'vue-router'

const SentMailsView = async () => import('@/views/development/SentMailsView.vue')

/** @type {import('vue-router').RouteRecordRaw[]} */
const routes: RouteRecordRaw[] = [
  {
    path: '/developer/sent-mails/:mailId',
    meta: { title: 'Versandte Emails', security: (roleHelper: RoleHelper) => roleHelper.developer },
    name: 'developer_sentmails_detail',
    props: true,
    component: SentMailsView
  }
]
export default routes
